export const changeFavicon = (url: string) => {
  let link =
    document.querySelector("link[rel~='icon']") as HTMLLinkElement | null;

  if (!link) {
    link = document.createElement("link") as HTMLLinkElement;
    link.rel = "icon";
    document.head.appendChild(link);
  }

  link.href = url;
};

export const changeDocumentTitle = (title: string) => {
  document.title = title;
};

